import { Skeleton } from '@mui/material';
import { FC } from 'react';

import classes from './Avatar.module.scss';

const AvatarSkeleton: FC = () => {
  return (
    <section className={classes.Loading}>
      <Skeleton variant="circular" />
      <Skeleton />
    </section>
  );
};

export default AvatarSkeleton;
